import { combineReducers } from '@reduxjs/toolkit';

import createRemindersSlice from '../../Reminder/CreateReminder/Actions/reducer';
import remindersListSlice from '../../Reminder/RemindersList/Actions/reducer';
import updateRemindersSlice from '../../Reminder/Update/Actions/reducer';
import vahedHayeBimehListSlice from '../../VahedHayeBimehList/Actions/reducer';

export const basicInfoReducers = combineReducers({
  remindersList: remindersListSlice,
  createReminder: createRemindersSlice,
  updateReminder: updateRemindersSlice,
  vahedHayeBimehList: vahedHayeBimehListSlice,
});
